import {Provider} from "react-redux";
import store from "./redux/store";
import Cart from "./pages/Cart";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import { useState } from "react";

function App() {
  const [state, setState] = useState('home');
  const setmenu = menu => setState(menu);   
  return (
  <Provider store={store}>   
    <Navbar setmenu={setmenu} />
    {state === 'home' && <Home />} 
    {state === 'cart' && <Cart />}    
  </Provider> 
  );
}

export default App;
